import { FormatHelper } from "../Helpers/FormatHelper.js";
import { DOMHelper } from "../Helpers/DOMHelper.js";
import { InputSlider } from "./component/InputSlider.js";
import { DataDriver } from "../Drivers/DataDriver.js";
import { BalloonForVLP } from "../VLP/BalloonForVLP.js";
import { PmDRSDatalayer } from "../Datalayer/PmDRSDatalayer.js";
import * as PaymentDisclosures from "../Helpers/PaymentDisclosures.js";

export class TabsWidget {
    /**
     * @param  {string} parentId dom element id
     * @return {void}
     */
    constructor(app, vehicle) {
        this.app = app;
        this.vehicle = vehicle;
        this.NPAToken = null;        
        this.tradeInData = {
            tradeInEstimate: 0,
        };
        this.paymentsData = {
            // lease: {},
            // finance: {},
            // balloon: {},
        };
        // this.addFeesToFinalPrice();//removed as api will add fees while doing the math
    }

    init(initialPaymentsData) {
        this.initialPaymentsData = initialPaymentsData;
        let $this = this;
        this.addHtml();

        this.getInitialPayemnts()
        this.setUrlToEasyRideLink();
        this.addHandlers();

        // this.setCashPanelValues();
        this.setTexts();
        this.setDefaultTabActive();
        this.setBackgroundColorToPurchaseBtns();
        this.getNPAToken();
    }    

    isVehicleBMW() {
        return this.vehicle.make.toLowerCase() == "bmw";
    }

    isVehicleTriumph() {
        return this.vehicle.make.toLowerCase() == "triumph";
    }

    isVehicleDucati(){
        return this.vehicle.make.toLowerCase() == "ducati";
    }

    isVehicleHarleyDavidson() {
        return this.vehicle.make.toLowerCase() == "harley-davidson";
    }

    // setTexts runs after preloaded payments are displayed, so read the balloon payment here too
    getBalloonTabTitle() {
        let payment = this.paymentsData?.balloon || this.initialPaymentsData?.balloon;
        if (payment) return this.app.pmdrs.getBalloonPaymentTitle(payment.balloonType, payment.balloonTypeLabel);
        if (this.isVehicleHarleyDavidson()) return "H-D Flex";
        return "Balloon";
    }

    isVehicleOnlyFinance() {//Temp function, the only finance logic could come from filtering api 
        let make = this.vehicle.make.toLowerCase();
        let makeList = ['polaris', 'royal enfield', 'indian motorcycle', 'cfmoto', 'honda', 'suzuki', 'yamaha', 'kawasaki'];
        return makeList.includes(make);
    }

    setDefaultTabActive() {
        var defaultTab = this.isVehicleBMW() ? 'balloon' : 'finance';
        defaultTab = this.app.siteSettings.default_tab || defaultTab;
        console.log("defaulttab: " + defaultTab);
        let tabElement = null;

        if (this.isVehicleDucati() || this.isVehicleTriumph()) {
            defaultTab = 'balloon';
        } else if (this.isVehicleOnlyFinance()) {
            defaultTab = 'finance';
        }

        //plan B
        var paymentData = this.paymentsData[defaultTab]; 
        if(!paymentData){
            switch(defaultTab){
            case 'balloon':
            case 'lease': 
                defaultTab = 'finance'; break;
            }
        }

        //plan c
        paymentData = this.paymentsData[defaultTab]; 
        if(!paymentData){
            defaultTab = 'cash';
        }

        tabElement = document.querySelector(
            this.getSelector("." + defaultTab + "-tab")
        );
        this.setTabActive(tabElement);

    }

    setTexts() {
        DOMHelper.setInnerHTML(
            this.getSelector(".balloon-title"),
            this.getBalloonTabTitle()
        );
    }

    // DRA UI Update 9/16/26: Figma's flat button, filled with the dealer's vlp_btn_color (black
    // only as a fallback) — passed as a CSS variable, not an inline background, so the
    // stylesheet's hover state (white fill, border/text in that same color) still applies.
    // No cart icon; text still comes from vlp_btn_text.
    setBackgroundColorToPurchaseBtns() {
        let purchaseBtns = document.querySelectorAll(this.getSelector(".pmdrs-personalize-deal-btn"));
        purchaseBtns.forEach((btn) => {
            if (this.app.siteSettings.vlp_btn_color) {
                btn.style.setProperty("--pmdrs-cta-color", this.app.siteSettings.vlp_btn_color);
            }
            btn.innerHTML = "<span>" + (this.app.siteSettings.vlp_btn_text || "Personalize Deal Now") + "</span>";
        });
    }

    getNPAToken() {
        this.NPAToken = sessionStorage.getItem('NPAAccessToken');
        let successCallback = (response) => {
            let npa = JSON.parse(response);
            this.NPAToken = npa.sessionToken;
            sessionStorage.setItem('NPAAccessToken', this.NPAToken);
        };
        this.app.pmdrs.NPAApi.login(successCallback, () => {});
        this.app.pmdrs.NPAApi.authenticate(
            {
                token: this.NPAToken
            }
        );
        return this.NPAToken;
    }

    testNPAToken() {

    }

    getActiveDealType() {
        let tabElement = document.querySelector(this.getSelector(".pmdrs-tab.active"));
        return this.getTabDealType(tabElement);
    }

    getTabDealType(tabElement) {
        if (!tabElement) return null;
        return ["finance", "lease", "balloon", "cash"].find(type => tabElement.classList.contains(type + "-tab")) || null;
    }

    setCashPanelValues(paymentObject) {
        let panelPrefix = this.getSelector(".cash-panel ");
        const vehicle = this.vehicle;
        let discounts = vehicle.pricing.data.discount.total;
        DOMHelper.setInnerHTML(panelPrefix + ".discounts-value", FormatHelper.currencyFormat(discounts));
        if (discounts == 0) {
            DOMHelper.addClass(panelPrefix + ".discounts-row", 'd-none');
        }

        DOMHelper.setInnerHTML(
            panelPrefix + ".sale-price-value",
            FormatHelper.currencyFormat(vehicle.finalPrice)
        );
        this.cashTradeInSlider.setValue(0);
        DOMHelper.triggerEvent(this.cashTradeInSlider.getInput(), "change");
    }

    addHtml() {
        let containerSelector = this.getSelector('');
        if(this.app.getSelector){//it goes to the root if the app has selector function
            containerSelector = this.app.getSelector("");
        }

        document
            .querySelector(containerSelector)
            .insertAdjacentHTML("beforeend", `<div class="pmdrs-widget d-none">
    <div class="pmdrs-tabs">
      <p class="pmdrs-error"></p>
      <div class="pmdrs-tabs-head">      
        <div class="pmdrs-tab balloon-tab" data-target="2">
          <div class="pmdrs-loading-wrapper balloon-loading"><div class="lds-dual-ring"></div></div>
          <div class="tab-text"><span class="balloon-title">Balloon</span></div>
          <span class="tab-value"><span class="balloon-monthly-value">$--</span>/mo.</span>
        </div>
        <div class="pmdrs-tab lower-payment finance-tab" data-target="0">
          <div class="pmdrs-loading-wrapper finance-loading"><div class="lds-dual-ring"></div></div>
          <div class="tab-text">Finance</div>
          <span class="tab-value"><span class="finance-monthly-value">$--</span>/mo.</span>
        </div>
        <!-- <div class="pmdrs-tab premier-tab" data-target="4">
          <div class="pmdrs-loading-wrapper premier-loading"><div class="lds-dual-ring"></div></div>
          <div class="tab-text">Premier</div>
          <span class="tab-value"><span class="premier-monthly-value">$--</span>/mo.</span>
        </div> -->
        <div class="pmdrs-tab lease-tab" data-target="1">
          <div class="pmdrs-loading-wrapper lease-loading"><div class="lds-dual-ring"></div></div>
          <div class="tab-text">Lease</div>
          <span class="tab-value"><span class="lease-monthly-value">$--</span>/mo.</span>
        </div>
        <!-- <div class="pmdrs-tab ttf-tab" data-target="5">
          <div class="pmdrs-loading-wrapper ttf-loading"><div class="lds-dual-ring"></div></div>
          <div class="tab-text">Triple Financing</div>
          <span class="tab-value"><span class="ttf-monthly-value">$--</span>/mo.</span>
        </div> -->
        <div class="pmdrs-tab cash-tab" data-target="3">
          <div class="pmdrs-loading-wrapper cash-loading"><div class="lds-dual-ring"></div></div>
          <div class="tab-text">Cash</div>
          <span class="tab-value"><span class="cash-tab-value">$--</span></span>
          <!-- <span class="tab-value">or Use My Bank</span> -->
        </div>
      </div>
      <div class="pmdrs-tabs-body">

        <div class="pmdrs-tab-panel active lower-payment">
            <div class="finance-panel">
                <p class="panel-error-msg pmdrs-c-2"></p>
                <!-- DRA UI Update 9/16/26 (Figma "VDP Widget") layout: label / price / subtitle /
                     "MSRP of $X | APR: Y%". The Figma "Excludes tax, license..." line is the payment
                     disclosure's subtitle now, and the disclosure itself is the .pmdrs-widget-disclaimer
                     at the bottom of the card, above the button (TabsWidget.updateActiveDisclaimer). -->
                <div class="panel-header">
                    <p class="pmdrs-label panel-header-label">Estimated Finance Payment</p>
                    <p class="panel-header-value"><span class="payment-figure finance-monthly-value">$--</span>/mo.</p>
                </div>
                <p class="payment-subtitle finance-panel-subtitle"></p>
                <p class="finance-based-price">MSRP of <span class="base-price-value"></span> | APR: <span class="finance-apr"></span></p>
                <p class="finance-panel-cashdown d-none">Cash Down: <span class="finance-cashdown-value"></span></p>
            </div>
        </div>

        <div class="pmdrs-tab-panel">
            <div class="lease-panel">
                <p class="panel-error-msg pmdrs-c-2"></p>
                <div class="panel-header">
                    <p class="pmdrs-label panel-header-label">Estimated Lease Payment</p>
                    <p class="panel-header-value"><span class="payment-figure lease-monthly-value">$--</span>/mo.</p>
                </div>
                <p class="payment-subtitle lease-panel-subtitle"></p>
                <p class="">MSRP of <span class="base-price-value"></span></p>
                <p class="lease-panel-cashdown d-none">Cash Down: <span class="lease-cashdown-value"></span></p>
                <!-- <div class=""><span class="pmdrs-c-2 payment-breakdown-btn cursor-pointer" data-parent=".lease-panel">See Payment Breakdown</span></div> -->
            </div>            
        </div>

        <div class="pmdrs-tab-panel">
            <div class="balloon-panel">
                <p class="panel-error-msg pmdrs-c-2"></p>
            
                <!-- <div class="balloon-form-not-allowed">
                    <p>Unable to calculate payment at this time. Please contact your local BMW Center. <a class="white-space-nowrap color-gray underline" aria-label="Opens in a new window" href="http://www.bmwmotorcyclesus.com/dealerlocator/" target="_blank">Click here</a> for a listing of BMW Centers</p>
                </div> -->
            
                <div class="balloon-panel-allowed">
                    <div class="panel-header">
                        <p>
                            <a id="balloon-panel-easy-ride" target="_blank" class="white-space-nowrap color-gray underline">
                                Learn about Easy Ride
                            </a>
                        </p>
                        <p class="pmdrs-label panel-header-label">Estimated Monthly Payment</p>
                        <p class="panel-header-value"><span class="payment-figure balloon-monthly-value">$--</span>/mo.</p>
                    </div>
                    <p class="payment-subtitle balloon-panel-subtitle"></p>
                    <p>And one single payment of <span class="balloon-payment"></span></p>
                    <p class="balloon-based-price">MSRP of <span class="base-price-value"></span></p>
                    <p class="balloon-customer-cash">Customer Cash: <span class="customer-cash-price-value"></span></p>
                    <p class="balloon-details-parent">APR: <span class="balloon-apr"></span><span class="balloon-panel-downpayment"> $-- Down Payment</span></p>
                </div>
            </div>            
        </div>
        
        <div class="pmdrs-tab-panel">
            <div class="cash-panel">
                <p class="panel-error-msg"></p>
                <div class="panel-header">
                    <p class="panel-header-label">Sale Price</p>
                    <p class="panel-header-value"><span class="payment-figure sale-price-value">$--</span></p>
                </div>
            </div>            
        </div>

        <div class="pmdrs-tab-panel"></div>
        <div class="pmdrs-tab-panel"></div>

        
    </div>    
        <!-- active tab's payment disclosure, under its terms with a divider (TabsWidget.updateActiveDisclaimer) -->
        <div class="pmdrs-widget-disclaimer"></div>
  
        <div class="pmdrs-unavailable">
            <div class="pmdrs-unavailable-curtain"></div>
            <p>Service Unavailable</p>
        </div>
    </div>
    <!-- single CTA outside the gray card; TabsWidget.setTabActive() keeps data-type on the active tab -->
    <button class="color-white pmdrs-personalize-deal-btn" data-type="finance"></button>
</div>`);
        
        // unhide widget
        if(!this.app.config.hideWidget){
            DOMHelper.removeClass(this.getSelector(""), 'd-none');
            DOMHelper.removeClass(this.getSelector(".pmdrs-widget"), 'd-none');//in case it's inside
        }

        DOMHelper.addClass(this.getSelector(""), 'pmdrs');//to apply all styles         
        return;       
    }    

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).replaceAll("_", " ");
    }

    getNPAToken() {
        this.NPAToken = sessionStorage.getItem("NPAAccessToken");
        if (this.NPAToken == null) {
            let successCallback = (response) => {
                let npa = JSON.parse(response);
                this.NPAToken = npa.sessionToken;
                sessionStorage.setItem("NPAAccessToken", this.NPAToken);
            };
            this.app.pmdrs.NPAApi.login(successCallback, () => {});
        }
        this.app.pmdrs.NPAApi.authenticate({ token: this.NPAToken });
        return this.NPAToken;
    }
    

    setTabActive(tabElement) {
        let target = tabElement.dataset["target"]; //index
        DOMHelper.removeClass(this.getSelector(".pmdrs-tab"), "active");
        DOMHelper.removeClass(this.getSelector(".pmdrs-tab-panel"), "active");

        tabElement.classList.add("active");
        document.querySelectorAll(this.getSelector(".pmdrs-tab-panel"))[target].classList.add("active");

        // one CTA for every tab now, so it follows the active tab (clickHandler reads data-type)
        let dealType = this.getTabDealType(tabElement);
        document.querySelectorAll(this.getSelector(".pmdrs-personalize-deal-btn")).forEach(btn => {
            btn.dataset["type"] = dealType;
        });
        this.updateActiveDisclaimer();
    }    

    setTabLowerPaymentClass(){        
        let paymentTypes = ['balloon', 'finance', 'lease', 'cash'];
        var lowerPaymentType = 'finance';
        var lowerPayment =  Number.MAX_SAFE_INTEGER;
        var widget = this;
        paymentTypes.forEach(type => {
            let paymentData = widget.paymentsData[type] || null;            
            if(!paymentData) return;//skip
            let payment = 0;
            switch (type) {
                case 'cash':
                case 'finance':
                case 'lease':
                    payment = paymentData.monthlyPayment;
                    break;
                case 'balloon':   
                    // if(!widget.isBalloonAllowed()) return;//skip
                    payment = paymentData.monthlyPayment;
                    break;                            
            }
            
            if(payment < lowerPayment){
                lowerPaymentType = type;
                lowerPayment=payment;
            }
        });
        //remove class
        DOMHelper.removeClass(this.getSelector(".pmdrs-tab.lower-payment"), "lower-payment");
        DOMHelper.removeClass(this.getSelector(".pmdrs-tab-panel.lower-payment"), "lower-payment");
        //add class
        DOMHelper.addClass(this.getSelector("." + lowerPaymentType + "-tab"), "lower-payment");
        let panelElement = document.querySelector(this.getSelector("." + lowerPaymentType + "-panel"));
        DOMHelper.addClass(panelElement.parentElement, "lower-payment");
    }


    setUrlToEasyRideLink() {
        let elem = document.querySelector(this.getSelector("#balloon-panel-easy-ride"));
        if(this.isBMW){
            if(elem){
                elem.setAttribute("href", "https://www.bmwmotorcycles.com/en/financial-services/easy-ride.html ");
            }
        }else{
            if(elem){
                elem.style.display = 'none';
            }
        }
        
    }

    getCashDown(type) {
        switch (type) {
            case 'cash':
                return 0;                        
            default:
                return 1000;
        }
    }

    getTradeIn(type) { 
        return 0;        
    }    

    showLoading(type) {
        document.querySelector(this.getSelector("." + type + "-loading")).style.display = "block";
    }

    hideLoading(type) {
        document.querySelector(this.getSelector("." + type + "-loading")).style.display = "none";
    }

    getVehicleRetailPrice() {//use this when you need MSRP
        return this.vehicle.retailPrice 
        || this.vehicle.pricing.data.internet;
    }

    //probably this is not the best way to do it, payment section asking to the widget
    // getSelectedCreditRating(type){                
    //     return this.app.getDefaultCreditRatingLabel(type);
    // }

    displayPaymentInfo(paymentObject, type) {
        let widget = this;
        let panelPrefix = widget.getSelector("." + type + "-panel ");

        let apr = parseFloat(paymentObject.moneyFactor).toFixed(2);

        let monthlyPayment = paymentObject.monthlyPayment;
        // console.log("********************");
        // console.log(monthlyPayment);

        //monthly payment
        DOMHelper.setInnerHTML(
            panelPrefix + "." + type + "-monthly-value",
            FormatHelper.currencyFormat(monthlyPayment, 0)
        );
        // monthly payment 2
        DOMHelper.setInnerHTML(
            widget.getSelector(".tab-value ." + type + "-monthly-value"),
            FormatHelper.currencyFormat(monthlyPayment, 0)
        );
        //sale price or purchase price
        let payment = paymentObject.purchasePrice;
        //cash: pm-drs-api computes this total (finalPriceDisplay, payment + doc fee) for
        //every engine, every request — matches the deal page's "Estimated Cash"/"Final
        //Price", which folds the same doc fee in instead of understating it.
        if (type == "cash") payment = paymentObject.finalPriceDisplay ?? paymentObject.payment;
        DOMHelper.setInnerHTML(
            panelPrefix + ".sale-price-value",
            FormatHelper.currencyFormat(payment, 0)
        );

        //MSRP        
        DOMHelper.setInnerHTML(widget.getSelector(".base-price-value"), FormatHelper.currencyFormat(this.getVehicleRetailPrice()));

        //APR
        DOMHelper.setInnerHTML(panelPrefix + "." + type + "-apr",apr + "%");
        
        //TERM
        DOMHelper.setInnerHTML(panelPrefix + "." + type + "-term-value",paymentObject.term);

        // Down payment
        DOMHelper.setInnerHTML(this.getSelector('.' + type + '-panel-downpayment'), ' $' + paymentObject.downPayment + " Down Payment");

        // Cash down line, shown per site (not on the cash tab)
        if (type !== 'cash' && this.app.pmdrs.config.accountId === 'southbaychryslerjeepdodgeram') {
            DOMHelper.setInnerHTML(panelPrefix + "." + type + "-cashdown-value", FormatHelper.currencyFormat(paymentObject.downPayment, 0));
            DOMHelper.removeClass(panelPrefix + "." + type + "-panel-cashdown", 'd-none');
        }

        if (type == "balloon") {
            //redesign layout keeps the "And one single payment of" line next to the disclosure
            DOMHelper.setInnerHTML(
                panelPrefix + "." + type + "-payment",
                FormatHelper.currencyFormat(paymentObject.balloonPayment)
            );
            DOMHelper.setInnerHTML(
                 widget.getSelector("." + type + "-title"),
                this.app.pmdrs.getBalloonPaymentTitle(paymentObject.balloonType, paymentObject.balloonTypeLabel)
            );
            DOMHelper.addClass(
                widget.getSelector(".balloon-tab"),
               paymentObject.balloonType + "-balloon-tab"
               // this.app.getBalloonType() + "-balloon-tab"
           );
        }

        //discounts
        const vehicle = this.vehicle;
        let discountTotal = vehicle.pricing?.data?.discount?.total ?? 0;
        let incentiveTotal = vehicle.pricing?.data?.incentive?.total ?? 0;
        let discounts = discountTotal + incentiveTotal;        
        DOMHelper.setInnerHTML(panelPrefix + ".discounts-value", FormatHelper.currencyFormat(discounts));
        if (discounts == 0) {
            DOMHelper.addClass(panelPrefix + ".discounts-row", 'd-none');
        }

        // customer cash
        let customerCash = paymentObject.customerCash || 0;
        DOMHelper.setInnerHTML(panelPrefix + ".customer-cash-value", FormatHelper.currencyFormat(customerCash));
        if (customerCash == 0) {
            DOMHelper.addClass(panelPrefix + ".customer-cash-row", 'd-none');
        }

        // customer cash for balloonCash
        DOMHelper.setInnerHTML(panelPrefix + ".customer-cash-price-value", FormatHelper.currencyFormat(customerCash));
        if (customerCash == 0) {
            DOMHelper.addClass(panelPrefix + ".balloon-customer-cash", 'd-none');
        }

        // cash price
        let cashPrice = this.getVehicleRetailPrice() - discounts - customerCash;
        DOMHelper.setInnerHTML(panelPrefix + ".cash-price-value", FormatHelper.currencyFormat(cashPrice));
        if (customerCash == 0 && discounts == 0) {
            DOMHelper.addClass(panelPrefix + ".cash-price-row", 'd-none');
        }
        
        DOMHelper.setInnerHTML(panelPrefix + ".apr-value", apr + "%");

        this.displayPaymentDisclosureTexts(paymentObject, type, apr);

        widget.setErrorMsg("");
    }

    //headline figure, subtitle and inline payment disclaimer for the finance, lease, balloon and cash panels.
    //The disclaimer is the payment's own (pm-drs-api DisclaimerHelper / the dealer's LenderDesk
    //template); Helpers/PaymentDisclosures.js only fills in when a payment comes without one, and
    //is what pmdra-ddc.js's lightweight VDP copy shows (its display-only fields carry no disclaimer).
    displayPaymentDisclosureTexts(paymentObject, type, apr) {
        let panelPrefix = this.getSelector("." + type + "-panel ");
        let texts = PaymentDisclosures.panelTexts(paymentObject, type, {
            stockNumber: this.vehicle.stockNumber,
            accountId: this.app.pmdrs.config.accountId,
        });
        if (!texts) return;
        if (texts.headline !== null) {
            //cents here so the headline matches the disclaimer figure exactly
            DOMHelper.setInnerHTML(panelPrefix + "." + type + "-monthly-value", texts.headline);
            DOMHelper.setTextContent(panelPrefix + "." + type + "-panel-subtitle", texts.subtitle);
        }
        this.disclosureTexts = this.disclosureTexts || {};
        //the payment's own backend text wins (may carry markup, e.g. <strong> in site-specific disclaimers)
        this.disclosureTexts[type] = paymentObject.disclaimerText
            ? { html: paymentObject.disclaimerText }
            : { text: texts.disclaimer };
        this.updateActiveDisclaimer();
    }

    // DRA UI Update 9/16/26: one disclosure under the CTA (Figma), for whichever tab is active
    updateActiveDisclaimer() {
        let container = document.querySelector(this.getSelector(".pmdrs-widget-disclaimer"));
        if (!container) return;
        let text = (this.disclosureTexts || {})[this.getActiveDealType()];
        container.innerHTML = "";
        if (!text || !(text.html || text.text)) return;
        let textEl = document.createElement("p");
        textEl.className = "payment-disclaimer-text";
        if (text.html) textEl.innerHTML = text.html;
        else textEl.textContent = text.text;
        container.append(textEl);
    }

    /**
     * to load all tabs
     * if no payment, no tab
     */
    getInitialPayemnts(){
        var $this = this;
        var types = this.app.pmdrs.allDealTypes;
        // types = ['finance', 'lease', 'balloon', 'cash'];//fixed array because removing premier and ttf
        types.forEach(function(dealType){
            $this.getInitialPayment(dealType);
        });
    }

    getInitialPaymentSucess(paymentObject, dealType) {   
        const type = dealType;     
        this.hideLoading(type);
        let panelPrefix = this.getSelector("." + type + "-panel ");
        DOMHelper.setInnerHTML(panelPrefix + " .panel-error-msg", "");
        let tabElement = document.querySelector(this.getSelector(".pmdrs-tab." + type + "-tab"));


        if (!paymentObject) {
            DOMHelper.setInnerHTML(
                panelPrefix + " .panel-error-msg",
                "(We are unable to provide an online quote on this vehicle using the information supplied)"
            );
            DOMHelper.setInnerHTML(
                this.getSelector("." + type + "-monthly-value"),
                FormatHelper.currencyFormat(0)
            );
            tabElement.style.display = "none";
            this.hideTabsHeadIfSingleTab();
            return;
        }

        console.log(type);
        console.log(paymentObject);
        this.displayPaymentInfo(paymentObject, type);

        this.paymentsData[type] = paymentObject;
        // this.app.setPaymentData(type, paymentObject);

        this.setErrorMsg("");
        try {
            this.setTabLowerPaymentClass()                    
        } catch (error) {
            console.error(error);
        }
    }

    // a lone tab reads as a duplicate title ("Cash" over the panel's "Cash"), not as a tab
    hideTabsHeadIfSingleTab() {
        let visibleTabs = [...document.querySelectorAll(this.getSelector(".pmdrs-tab"))]
            .filter(tab => getComputedStyle(tab).display !== "none");
        let head = document.querySelector(this.getSelector(".pmdrs-tabs-head"));
        if (head) head.style.display = visibleTabs.length <= 1 ? "none" : "";
    }

    getInitialPayment(type) {
        let widget = this;
        this.showLoading(type);        

        let existingData = this.initialPaymentsData?.[type];
        if(existingData){
            this.getInitialPaymentSucess(existingData, type);
        }else{
            this.app.pmdrs.dataDriver.getInitialPayment(
                type,
                (paymentObject)=> {
                    widget.getInitialPaymentSucess(paymentObject, type);
                },
                //ON ERROR
                (response) => {
                    response = JSON.parse(response);
                    console.log(response);
                    let msg = response.Message;
                    if (response.ErrorCode == 0) {
                        widget.showUnavailableCurtain(true, msg);
                    }
                    widget.setErrorMsg(msg);
                }
            );
        }

    }        

    setErrorMsg(msg) {
        document.querySelector(this.getSelector(".pmdrs-error")).innerHTML = msg;
    }

    showUnavailableCurtain(flag, message) {
        document.querySelector(this.getSelector(".pmdrs-unavailable")).style.display = "flex";
    }    

    setBtnClickCallback(callbackFunction){
        this.btnClickCallback = callbackFunction;
    }    

    addHandlers() {
        let widget = this;

        //TABS
        let tabHandler = function () {
            let tabElement = this;
            widget.setTabActive(tabElement);
        };
        DOMHelper.addHandler(this.getSelector(".pmdrs-tab"), "click", tabHandler);

        //SUBMIT
        let clickHandler = function (event) {
            var btn = event.target;                        
            if (!btn.matches('button')) {
                btn = btn.closest('button');
            }
            var dealType = btn.dataset['type'];
                       
            if(widget.btnClickCallback){
                widget.btnClickCallback(dealType)
            }
            
            return false;
        };

        DOMHelper.addHandler(this.getSelector(".pmdrs-personalize-deal-btn"), "click", clickHandler);        
    }

    updateUI() {
        DOMHelper.setInnerHTML(".trade-in-value", FormatHelper.currencyFormat(this.tradeInData.tradeInEstimate));

        let tradeInBtn = document.querySelector(this.getSelector(".open-trade-in-btn"));
        if (this.tradeInData.tradeInEstimate > 0) {
            tradeInBtn.classList.add("set");
        } else {
            tradeInBtn.classList.remove("set");
        }
    }

    getSelector(selector) {
        if(this.app.getSelector){
            return this.app.getSelector(".pmdrs-widget " + selector);
        }
        var containerSelector=`.${this.app.config.tabsWidgetClass}[data-vin="${this.vehicle.vin}"]`;
        return containerSelector + " " + selector;    
    }

    getContainerElement() {        
        var containerElement = document.querySelector(this.getSelector(''));
        if(!containerElement){
            console.error("Missing container " + containerSelector);
        }
        return containerElement;
    }
}
